import { setStore, removeStore } from '@/utils/storage'

export default {
    /**
     * @param commit
     * @param data
     * @constructor
     */
    SET_LOGGED({ commit }, data) {
        setStore('userInfo', data);
        commit('SET_LOGGED', data);
    },



    /**
     * @param commit
     * @constructor
     */
    SET_LOGOUT({ commit }) {
        removeStore('userInfo');
        commit('SET_LOGOUT');
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js